export const LOCATION_ZOOM_LEVEL = 18;
